import React, { Fragment } from 'react'
import './QuickEntry.less'
import { Flex } from 'antd-mobile'
import { goIndex } from '@/assets/js/utils'
class QuickEntry extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            left: 0, // slider的偏移量
            list: [] // 分割数据后的list-[每页显示的入口]
        }
    }

    componentDidMount () {
        this.init()
    }

    // 初始化list
    init () {
        let { sublist = [], style = {} } = this.props.data
        if (!style) style = {}
        // 默认数据
        const { rows = '2', columns = '4', isSlide = '1' } = style
        const { list } = this.state
        // 拷贝不改变原来的sublist值
        const sublistCopy = [...sublist]
        while (sublistCopy.length > 0) {
            if (isSlide === '1') {
                list.push(sublistCopy.splice(0, rows))
            } else if (isSlide === '0') {
                list.push(sublistCopy.splice(0, columns * rows))
            }
        }
        this.setState({ list })
    }

    /**
  * 滚动调用的函数, 设置left, slide 也滑动
  * wrap.scrollLeft/wrap.scrollWidth-wrap.offsetWidth(750)=
  * slideInner.left/slideWrap-width-slideInner.width(40)
  */
    scrollFun () {
        const wrap = document.querySelector('#wrap')
        this.setState({
            left: wrap.scrollLeft / (wrap.scrollWidth - wrap.offsetWidth)
        })
    }

    render () {
        const { data: { position, style = {}, trackId, sublist }, buriedPointEvent } = this.props
        const {
            backgroundColor,
            backgroundPicUrl,
            isSlide = '1',
            columns = '4',
            rows = '2',
            textColor,
            iconHeight,
            marginTopBottom,
            marginLeftRight
        } = style
        const { left, list } = this.state
        const marginR = marginLeftRight ? marginLeftRight * 2 / 75 : 0
        /**
     * 滑块的长度
     * isSlide 1 可滑动
     * - 总的入口的长度/rows, 向上取整数, 即一共有Math.ceil(len/rows)列
     * - 一共有columns列,每列的长度为10/columns rem
     * - 即总的长度Math.ceil(len/rows) * 10/columns + 'rem'
     *
     * isSlide 0 不可滑动
     * - 每一个完整的页面有rows*columns个入口
     * - 一共用 Math.floor(len/rows/columns)个完整的页面,长度为 : *10+'rem'
     * - 最后一个页面有 n = Math.floor(len%(rows/columns) 个入口
     * - 每一行有columns个入口
     * - n>columns,则站一个页面,第一行平铺,n<columns, 则显示columns个
     */
        const width1 = () => {
            const len = sublist.length
            if (isSlide === '1') {
                return Math.ceil(len / rows) * (10 - marginR) / columns + 'rem'
            } else {
                const a1 = Math.floor(len / rows / columns) * (10 - marginR)
                const a2 = len % (columns * rows) >= columns ? (10 - marginR) : len % (columns * rows) * ((10 - marginR) / columns)
                return a1 + a2 + 'rem'
            }
        }
        // className='item'的宽度
        const width2 = (item) => {
            if (isSlide === '1') {
                return (10 - marginR) / columns + 'rem'
            } else {
                return item.length * (10 - marginR) / columns + 'rem'
            }
        }
        // slideWrap.width = 有Math.ceil(sublist.length / columns / rows)屏的入口*每屏幕40px
        const slideWidth = Math.ceil(sublist.length / columns / rows) * 40
        return (
            <div className={'bg'} style={{
                padding: `0 0 ${10 / 75}rem 0`,
                backgroundColor,
                margin: `${marginTopBottom ? marginTopBottom / 75 : 0}rem ${marginLeftRight ? marginLeftRight / 75 : 0}rem`,
                backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : '',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                color: textColor
            }}>
                <div style={{
                    height: iconHeight
                        ? `${rows === '2' ? (iconHeight + 16) * 2 / 75 : (iconHeight + 16) / 75}`
                        : `${rows === '2' ? 290 / 75 : 135 / 75}rem`,
                    overflow: 'hidden'
                }}>
                    <div
                        id="wrap"
                        onScroll={() => this.scrollFun()}
                        style={{
                            overflowX: 'scroll',
                            width: `${10 - marginR}rem`
                        }}
                    >
                        <Flex align="start" className="aa" style={{
                            width: width1(),
                            minWidth: '100%',
                            height: iconHeight
                                ? `${rows === '2' ? (iconHeight + 16) * 2 / 75 : (iconHeight + 16) / 75}`
                                : `${rows === '2' ? 290 / 75 : 135 / 75}rem`,
                            padding: `0 0 ${30 / 75}rem 0`
                        }}>
                            {list.map((item, idx) => (
                                <Flex
                                    key={idx}
                                    wrap="wrap"
                                    className='item'
                                    style={{ width: width2(item), maxWidth: `${10 - marginR}rem` }}
                                >
                                    {item.map((entryItem, index) => {
                                        return (
                                            <div
                                                className="statistics-dom"
                                                key={isSlide === '1' ? entryItem.id : index}
                                                onClick={() => {
                                                    buriedPointEvent({
                                                        button_name: `${trackId}-${entryItem.title}`,
                                                        button_id: `${entryItem.id}`,
                                                        button_order: `${(idx ? idx * list[0].length : 0) + index + 1}`,
                                                        area_order: position,
                                                        button_area: `${position}-${trackId}`
                                                    })
                                                    goIndex(entryItem.url, trackId, entryItem.keyword)
                                                }}
                                                style={{
                                                    width: (10 - marginR) / columns + 'rem',
                                                    margin: `${16 / 75}rem 0`
                                                }} >
                                                <div
                                                    className="item-icon"
                                                    style={{
                                                        // background: `url(${
                                                        //   entryItem.imageUrl
                                                        // }) no-repeat center`,
                                                        // backgroundSize: 'contain',
                                                        width: `${(10 - marginR) / columns}rem`,
                                                        height: iconHeight ? iconHeight / 75 + 'rem' : 60 / 75 + 'rem'
                                                    }}>
                                                    <img src={entryItem.imageUrl} alt='' style={{
                                                        maxWidth: `${(10 - marginR) / columns}rem`,
                                                        height: iconHeight ? iconHeight / 75 + 'rem' : 60 / 75 + 'rem',
                                                        display: 'block',
                                                        margin: 'auto'
                                                    }} />
                                                    {entryItem.subscriptsUrl && <img className="item-icon-subscripts" src={entryItem.subscriptsUrl} alt={entryItem.subscriptsUrl} />}
                                                </div>
                                                <div className={'item-title'}>{entryItem.title}</div>
                                            </div>
                                        )
                                    })}
                                </Flex>
                            )
                            )}
                        </Flex>
                    </div>
                </div>
                {isSlide === '1' && (
                    <Fragment>
                        <div
                            className={'slideWrap'}
                            style={{ width: slideWidth / 75 + 'rem' }}
                        >
                            <div
                                className="slideInner"
                                style={{ left: (slideWidth - 40) * left / 75 + 'rem' }}
                            />
                        </div>
                    </Fragment>
                )}
            </div>
        )
    }
}

export default QuickEntry
